import { useFindMenu, useLocale } from 'hooks'
import //   BrandNode,
//   CollezioneNode,
//   MagazineNode,
//   ProgettiNode,
//   SoluzioneNode,
'@gql/graphql'
import { PlaceholderReact } from '@components/molecules'
import {
  Banner,
  BrandsSection,
  CollezioniSection,
  EffettiSection,
  GenericCardSwiper,
  Page,
  Prefooter,
  SoluzioniSection,
} from 'components/organisms'
import styles from './HomeTemplate.module.sass'
import { useEffect } from 'react'
import { collezioneToTrack, trackingEcommerceEvent, uniformData } from '@utils/gtm'

interface Props {
  pagina?: any
  soluzioni?: any[] // SoluzioneNode[]
  collezioni?: any[] // CollezioneNode[]
  progetti?: any[] // ProgettiNode[]
  magazine?: any[] // MagazineNode[]
  brands?: any[] // BrandNode[]
  effetti?: any[]
}

const HomeTemplate = (props: Props) => {
  const {
    pagina = {},
    brands = [],
    soluzioni = [],
    effetti = [],
    collezioni = [],
    progetti = [],
    magazine = [],
  } = props

  const { isAmerica } = useLocale()
  const defaultContent1 = pagina?.pagebuilders?.find((x) => x.key === 'main') ?? null

  const homeMenu = useFindMenu('pagina-homepage')
  const brandsMenu = useFindMenu('brands-slider', homeMenu)
  const collezioniMenu = useFindMenu('collezioni-slider', homeMenu)
  const progettiMenu = useFindMenu('progetti-slider', homeMenu)
  const soluzioniMenu = useFindMenu('soluzioni-slider', homeMenu)
  const effettiMenu = useFindMenu('effetti-slider', homeMenu)
  const ispirazioniMenu = useFindMenu('ispirazioni-slider', homeMenu)
  const ergonMenu = useFindMenu('ergon-banner', homeMenu)
  const quickshipMenu = useFindMenu('quickship-banner', homeMenu)

  const handleClickTracking = (item, index) => {
    trackingEcommerceEvent('select_item', {
      item_list_id: pagina?.pk || 0,
      item_list_name: uniformData(pagina?.nome) || '',
      items: [collezioneToTrack(item, index, pagina)],
    })
  }

  useEffect(() => {
    trackingEcommerceEvent('view_item_list', {
      item_list_id: pagina?.pk,
      item_list_name: uniformData(pagina?.nome) || '',
      items: collezioni.map((p, index) => {
        return collezioneToTrack(p, index, pagina)
      }),
    })
  }, [])

  return (
    <Page pagina={pagina} className={`${styles.root}`} transparentHeader>
      <main>
        <div className={styles.placeholderContent}>
          <PlaceholderReact
            contentTypeId={pagina.model}
            objectId={pagina.pk}
            pkey={'main'}
            serverSideContent={defaultContent1}
          />
        </div>
        <BrandsSection brands={brands} item={brandsMenu} theme="neutral10" />
        <SoluzioniSection soluzioni={soluzioni} item={soluzioniMenu} theme="white" />
        {isAmerica && (
          <>
            <Banner item={ergonMenu} type="right" theme={'neutral20'} />
            <Banner item={quickshipMenu} />
          </>
        )}
        <CollezioniSection
          collezioni={collezioni}
          item={collezioniMenu}
          theme="neutral20"
          handleClickTracking={handleClickTracking}
        />
        <EffettiSection effetti={effetti} item={effettiMenu} theme="white" />
        <GenericCardSwiper
          id="home_progetti"
          item={{
            ...progettiMenu,
            children: progetti.map((x) => ({
              pk: x.id,
              name: x.title,
              url: x.url,
              image: x.imageUrl,
              imageAlt: x.imageAlt,
            })),
          }}
          theme={'neutral20'}
        />
        <GenericCardSwiper
          id="home_ispirazioni"
          item={{
            ...ispirazioniMenu,
            children: magazine.map((x) => ({
              pk: x.pk,
              name: x.title,
              url: x.url,
              image: x.imageUrl,
              imageAlt: x.imageAlt,
            })),
          }}
        />
        <Prefooter />
      </main>
    </Page>
  )
}

export default HomeTemplate
